import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorMessageHandler } from 'src/app/helpers/error-handler';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';

@Injectable()
export class ApiService {

  public service: any;
  constructor(
    private http: HttpClient,
    private errorHandler: ErrorMessageHandler,
    private authenticationService: AuthService
  ) { }

  get headers() {
    if (this.authenticationService.currentUserValue) {
      if (this.service == 'report') {
        var reportToken = this.authenticationService.getReportToken();
        return new HttpHeaders({
          'Content-Type': 'application/json',
          'Accept': 'aplication/json',
          'Access-Control-Allow-Origin': '*',
          'Authorization': 'Bearer ' + reportToken,
        })
      }

      var token = this.authenticationService.getToken();
      return new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'aplication/json',
        'Access-Control-Allow-Origin': '*',
        'Authorization': 'Bearer ' + token.token,
      })

    } else {
      return new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'aplication/json',
        'Access-Control-Allow-Origin': '*',
      })
    }
  }

  get recommendationHeaders() {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'aplication/json',
      //'Access-Control-Allow-Origin': '*',
    })
  }

  get formDataHeaders() {
    var token = this.authenticationService.getToken();
    return new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'Authorization': 'Bearer ' + token.token,
    })
  }

  get fileHeaders() {
    var reportToken = this.authenticationService.getReportToken();
    return new HttpHeaders({
      //'responseType': 'blob',
      'Accept': 'aplication/json',
      'Content-Type': 'text/csv; charset=UTF-8',
      'Access-Control-Allow-Origin': '*',
      'Authorization': 'Bearer ' + reportToken,
    })

  }

  private handleError(error: HttpErrorResponse, handler: ErrorMessageHandler) {
    console.log(error)
    if (error.error instanceof ProgressEvent) {
      handler.showErrorMessage("Couldn't connect to remote server.");
    } else if (error.error.message) {
      if (error.error.message == 'Unauthenticated.') {
        this.authenticationService.logout()
        window.location.href = '/login'
      }
      handler.showErrorMessage(error.error.message)
      return throwError(
        error.error.message
      );
    } else {
      handler.showErrorMessage(error.error.message)
      return throwError(
        error.error.message
      );
    }
    //handler.showErrorMessage('Could not connect to remote server.')
    return throwError(
      'Could not connect to remote server.'
    );
  }

  getBaseUrl(service: string) {
    if (service == 'developer') {
      return `${environment.developer.api_base_url}`;
    } else if (service == 'report') {
      return `${environment.report.api_base_url}`;
    } else if (service == 'data_ai') {
      return `${environment.data_ai.api_base_url}`;
    }
    return ''
  }

  setService(service: any) {
    this.service = service;
  }
  get(path: string, service: string): Observable<any> {
    this.setService(service);
    return this.http
      .get<any>(this.getBaseUrl(service) + `${path}`, { headers: this.headers })
      .pipe(catchError(err => this.handleError(err, this.errorHandler)))
  }

  put(path: string, body: Object = {}, service: string): Observable<any> {
    this.setService(service);
    return this.http
      .put<any>(this.getBaseUrl(service) + `${path}`, JSON.stringify(body), { headers: this.headers })
      .pipe(
        catchError(err => this.handleError(err, this.errorHandler))
      )
  }

  post(path: string, body: Object = {}, service: string): Observable<any> {
    this.setService(service);
    return this.http
      .post<any>(this.getBaseUrl(service) + `${path}`, JSON.stringify(body), { headers: service == 'data_ai' ? this.recommendationHeaders : this.headers }
      )
      .pipe(
        catchError(err => this.handleError(err, this.errorHandler))
      );
  }

  postFormData(path: string, body: Object = {}, service: string): Observable<any> {
    this.setService(service);
    return this.http
      .post<any>(this.getBaseUrl(service) + `${path}`, body, { headers: this.formDataHeaders }
      )
      .pipe(
        catchError(err => this.handleError(err, this.errorHandler))
      );
  }

  delete(path: string, service: string): Observable<any> {
    this.setService(service);
    return this.http
      .delete<any>(this.getBaseUrl(service) + `${path}`, { headers: this.headers })
      .pipe(
        catchError(err => this.handleError(err, this.errorHandler))
      );
  }

  getFile(path: string, service: string) {
    this.setService(service);
    this.http
      .get<any>(this.getBaseUrl(service) + `${path}`, { responseType: 'text' as 'json' })
      .subscribe((csvData: any) => {
        const blob = new Blob([csvData], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'your-file-name.csv'; // Replace with the desired file name
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      });


  }

}
